import React from "react";
import {
  Button,
  Col,
  Dropdown,
  Form,
  Input,
  Menu,
  Row,
  Select,
  Slider,
  Space,
  Switch,
} from "antd";
import { useRef } from "react";
import { LogEvents, LoggerContext } from "../../../../context/logging";
const { Option } = Select;
const SearchFilter = (props) => {
  const formRef = useRef();
  const logger = React.useContext(LoggerContext);

  const handleSearch = (value) => {
    logger.log(LogEvents.searchByStatus, {});
    const updateValue = formRef.current.getFieldsValue();
    props.fetchPo({ is_deleted: updateValue.type, project: props?.project_id });
  };
  return (
    <React.Fragment>
      <Form ref={formRef}>
        <Row gutter={24} className="align-items-center">
          <Col sm={6}>
            <Form.Item name={"type"}>
              <Select
                allowClear
                // size="large"
                onChange={(e) => {
                  handleSearch(e);
                }}
                placeholder="Search by status"
                className="w-100"
              >
                <Option key={1} value={false}>
                  Active Pos
                </Option>
                <Option key={2} value={true}>
                  Discarded Pos
                </Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </React.Fragment>
  );
};

export default SearchFilter;
